export default __webpack_public_path__ + "static/E-P-5-abce6e6bf42ccbba1ddad10afb82e369.png";